import helpers from './helpers';
import functions from './functions';

let hostname = window.location.hostname;
const type = hostname === "localhost" || hostname === "10.226.110.238" ? "localtostage" : (hostname === "secure-developments.com" || hostname === 'stage.com.ar') ? "stage" : hostname === "pdachevrolet.apps.pcfepgw.gm.com" ? "pp" : "prod";
const stage = type == "localtostage" ? "http://localhost:8083/" : "https://secure-developments.com/stage/commonwealth/argentina/plan_chevrolet/";
// const base = type === "localtostage" ? stage + "data/jsons" : type === "stage" ? "../data" : "../data";
const base = "../data/jsons";
const urlbase = type == 'prod' ? 'https://planchevrolet.com.ar/' : type === 'pp' ? 'https://www-chevrolet-com-ar.prd1a.wpx.gm.com/plan-chevrolet/' : type === 'stage' ? 'https://www-chevrolet-com-ar.prd1a.wpx.gm.com/plan-chevrolet/' : '';
const urls = {
  urlbase,
  stage,
  type,
  home: base + "/home.json",
  model: base + "/models.json",
  models: base + "/models.json",
  faq: base + "/faq.json",
  provinces: base + "/provincias.json",
  dealerList: base + "/listDealers.json",
  dealerCp: base + "/dealers/{idProvincia}.json",
  dealerServices: base + "dealer_services.json",
  documents: base + "/documents.json",
  clients: {
    acts: base + "/acts.json",
    groups: base + "/groups.json",
    act: base + "/acts/{act}.json",
    ActNexts: base + "/actsnexts.json"
  },
  mapsKey: type === "localtostage" ? "AIzaSyCuTP6UDiBkOEsCZ1wKO99dFjFOoYBkb4Q" : "AIzaSyDaBUdAWCy8gm7LUJWNArk3szx_bPw6edU"
};

urls.leadbix = type === "prod" ? "https://gmb2c.gm.com/bix/rest-api/public/prospect" : "https://gmb2c.pp.gm.com/bix/rest-api/public/prospect";
urls.sibel = {
  api: "https://secure-developments.com/commonwealth/argentina/sibel/send_sibel.php",
  environment: type === "localtostage" || type === "stage" ? "test" : "prod"
};

const api = () => {
  let service = helpers();

  return {
    models: function () {
      const getList = (cb) =>
        service
        .get(urls.models)
        .then(data => Promise.resolve(functions.orderSort(data, true)))
        .then(data => cb(data));

      const getSingleById = (id, cb) =>
        service
        .get(urls.model, {
          idModel: id
        })
        .then(data => Promise.resolve(functions.orderSort(data, true, ["images", "quota", "tags"])))
        .then(data => cb(data));

      const getSingleByUrl = (name, cb) =>
        service
        .get(urls.model)
        .then(data => {
          let d = data.filter(d => d.url == name);
          return d[0];
        })
        .then(data => Promise.resolve(functions.orderSort(data, true, ["images", "quota", "tags"])))
        .then(data => cb(data));

      return {
        getList,
        getSingleById,
        getSingleByUrl
      };
    },

    provinces: function () {
      const getList = (cb) =>
        service
        .get(urls.provinces)
        .then(data => cb(data));

      return {
        getList
      };
    },

    clients: function () {
      const getActs = (cb) => {
        service.get(urls.clients.acts).then(data => cb(data));
      };

      const getGroups = (cb) => {
        service.get(urls.clients.groups).then(data => cb(data));
      };

      const getNexts = (cb) => {
        service.get(urls.clients.ActNexts).then(data => cb(data));
      };

      const getAct = (act, group, cb) => {
        service.get(urls.clients.act.replace('{act}', act), {
          idAct: act,
          idGroup: group
        })
        .then(function(data) {
          if(group !== '') {
            data = data.filter(d => d.group == group);
          }
          return data;
        }).then(data => cb(data));
      };

      return {
        getActs,
        getGroups,
        getNexts,
        getAct
      };
    },

    dealers: function () {
      const maxdistance = 200;

      const get = (province, cb) => {
        service.get(urls.dealerCp.replace('{idProvincia}', province), {
          idProvincia: province
        }).then(data => cb(data));
      };

      const getByCp = (cp, cb) => {
        service.get(urls.dealerCp, {
          cp,
          maxdistance
        }).then(data => cb(data));
      };

      const getByLatLng = (lat, lng, cb) => {
        service.get(urls.dealerList, {
          lat,
          lng,
          maxdistance
        }).then(data => cb(data));
      };

      const getAll = (cb) => {
        service.get(urls.dealerList, {
          lat: -32.864781,
          lng: -64.477228,
          maxdistance: 9999
        }).then(data => cb(data));
      };

      const getDealerServices = (cb) => {
        service.get(urls.dealerServices, {})
        .then(data => cb(data));
      };

      return {
        get,
        getByCp,
        getByLatLng,
        getAll,
        getDealerServices
      }
    },

    home: function () {
      const getMH = (cb) =>
        service
        .get(urls.home)
        .then(data => cb(data));

      return {
        getMH
      };
    },

  }
}

export {
  type,
  api,
  urls
};